import React from 'react'

const ConvertTo: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg width={40} height={40} fill="none" {...props}>
      <path
        d="M24.5858 18.7071L20.2929 14.4142L21.7071 13L28.4142 19.7071L21.7071 26.4142L20.2929 25L24.5858 20.7071H20V18.7071H24.5858Z"
        fill="#557A8F"
      />
      <path d="M12 18.7071H14V20.7071H12V18.7071Z" fill="#557A8F" />
      <path d="M18 18.7071H16V20.7071H18V18.7071Z" fill="#557A8F" />
    </svg>
  )
}

export default ConvertTo
